module.exports = __webpack_public_path__ + "static/media/criteria-8.1-rsp.e97d2a46.jpg";